import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGear = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='gear_svg__a'
      width={16}
      height={18}
      x={2}
      y={1}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        fillRule='evenodd'
        d='M10 6.667a3.333 3.333 0 1 1 0 6.667 3.333 3.333 0 0 1 0-6.667m0 1.667a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333'
        clipRule='evenodd'
      />
      <path
        fill={props.color}
        fillRule='evenodd'
        d='M8.75 1.843a2.5 2.5 0 0 1 2.5 0l5.189 2.997a2.5 2.5 0 0 1 1.25 2.164v5.993a2.5 2.5 0 0 1-1.25 2.165l-5.19 2.996a2.5 2.5 0 0 1-2.5 0l-5.19-2.996a2.5 2.5 0 0 1-1.25-2.165V7.004A2.5 2.5 0 0 1 3.56 4.84zm1.666 1.444a.83.83 0 0 0-.833 0l-5.19 2.996a.83.83 0 0 0-.417.721v5.993c0 .297.16.572.417.721l5.19 2.997a.83.83 0 0 0 .833 0l5.19-2.997a.83.83 0 0 0 .416-.72V7.003a.83.83 0 0 0-.416-.72z'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#gear_svg__a)'>
      <path fill={props.color} d='M0 0h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgGear)
export default ForwardRef
